module.exports = __webpack_public_path__ + "static/media/focus-cercle.8cb11dc1.png";